import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import {Observable} from 'rxjs';

import {AuthService} from '../../../@tpl-auth/services/auth.service';
import {UrlsConstant} from '../../../@ksm-core/shared/constants/urls.constant';
import {RouteNavigationConstant} from '../../../@ksm-core/shared/constants/route-navigation.constant';

// noinspection JSAnnotator
@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(private authService: AuthService,
              private router: Router) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivateRoute(state.url);
  }

  canActivateRoute(url: string): boolean {
    if (url.includes(UrlsConstant.register)) {
      return true;
    } else if (!url.includes(UrlsConstant.login)) {
      if (this.authService.isLoggedIn()) {
        return true;
      }
      this.authService.redirectUrl = url;
      this.router.navigate([RouteNavigationConstant.login]).then(r => {
        return r;
      });
      return false;
    } else {
      if (this.authService.isLoggedIn()) {
        this.router.navigate(['/']).then(r => {
          return r;
        });
        return false;
      }
      return true;
    }
  }

}
